import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const SUBSCRIPTION_API_URL = `${API_HOST}/api/subscription`;
const SUBSCRIPTION_PROGRAM_ORDER_API_URL = `${API_HOST}/api/subscription/programContract/order`;

function* subscriptionProgramOrderRefund() {
  yield takeEvery(actions.SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SUBSCRIPTION_PROGRAM_ORDER_API_URL}/refund`,
        formData,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_ENDED });
    }
  });
}

function* subscriptionProgramOrderRefundByManually() {
  yield takeEvery(
    actions.SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY,
    function* (action) {
      const { formData, onSuccess } = action;
      try {
        const res = yield call(
          [axios, 'post'],
          `${SUBSCRIPTION_PROGRAM_ORDER_API_URL}/manuallyRefund`,
          formData,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (error) {
        yield handleError(error);
      } finally {
        yield put({ type: actions.SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_BY_MANUALLY_ENDED });
      }
    },
  );
}

function* searchSubscriptionProgramContracts() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACTS_END });
    }
  });
}

function* searchSubscriptionProgramContractOrders() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/order?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_PROGRAM_CONTRACT_ORDERS_END });
    }
  });
}

function* searchMemberPrivilegeUsageTransactionRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/memberPrivilege?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_PRIVILEGE_USAGE_TRANSACTION_RECORDS_END });
    }
  });
}

function* searchSubscriptionActivities() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_ACTIVITIES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/activity?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_ACTIVITIES_END });
    }
  });
}

function* findSubscriptionActivity() {
  yield takeEvery(actions.FIND_SUBSCRIPTION_ACTIVITY, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SUBSCRIPTION_API_URL}/activity/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SUBSCRIPTION_ACTIVITY_END });
    }
  });
}

function* createSubscriptionActivity() {
  yield takeEvery(actions.CREATE_SUBSCRIPTION_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SUBSCRIPTION_API_URL}/activity`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SUBSCRIPTION_ACTIVITY_END });
    }
  });
}

function* updateSubscriptionActivity() {
  yield takeEvery(actions.UPDATE_SUBSCRIPTION_ACTIVITY, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SUBSCRIPTION_API_URL}/activity`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_ACTIVITY_END });
    }
  });
}

function* deleteSubscriptionActivities() {
  yield takeEvery(actions.DELETE_SUBSCRIPTION_ACTIVITIES, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SUBSCRIPTION_API_URL}/activity`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_SUBSCRIPTION_ACTIVITIES_END });
    }
  });
}

function* searchSubscriptionPrograms() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_PROGRAMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/program?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_PROGRAMS_END });
    }
  });
}

function* findSubscriptionProgram() {
  yield takeEvery(actions.FIND_SUBSCRIPTION_PROGRAM, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${SUBSCRIPTION_API_URL}/program/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SUBSCRIPTION_PROGRAM_END });
    }
  });
}

function* createSubscriptionProgram() {
  yield takeEvery(actions.CREATE_SUBSCRIPTION_PROGRAM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${SUBSCRIPTION_API_URL}/program`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_SUBSCRIPTION_PROGRAM_END });
    }
  });
}

function* updateSubscriptionProgram() {
  yield takeEvery(actions.UPDATE_SUBSCRIPTION_PROGRAM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SUBSCRIPTION_API_URL}/program`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_PROGRAM_END });
    }
  });
}

function* deleteSubscriptionPrograms() {
  yield takeEvery(actions.DELETE_SUBSCRIPTION_PROGRAMS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${SUBSCRIPTION_API_URL}/program`, {
        data: formData,
      });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_SUBSCRIPTION_PROGRAMS_END });
    }
  });
}

function* getSubscriptionReceiptConfiguration() {
  yield takeEvery(actions.GET_SUBSCRIPTION_RECEIPT_CONFIGURATION, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SUBSCRIPTION_API_URL}/configuration/receipt`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED });
    }
  });
}

function* updateSubscriptionReceiptConfiguration() {
  yield takeEvery(actions.UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SUBSCRIPTION_API_URL}/configuration/receipt`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_RECEIPT_CONFIGURATION_ENDED });
    }
  });
}

function* getSubscriptionHandlingFeeConfiguration() {
  yield takeEvery(actions.GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SUBSCRIPTION_API_URL}/configuration/handlingFee`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED });
    }
  });
}

function* updateSubscriptionHandlingFeeConfiguration() {
  yield takeEvery(actions.UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${SUBSCRIPTION_API_URL}/configuration/handlingFee`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_HANDLING_FEE_CONFIGURATION_ENDED });
    }
  });
}

function* getSubscriptionRenewalConfiguration() {
  yield takeEvery(actions.GET_SUBSCRIPTION_RENEWAL_CONFIGURATION, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SUBSCRIPTION_API_URL}/configuration/renewal`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED });
    }
  });
}

function* searchSubscriptionRenewalNotificationConfigurations() {
  yield takeEvery(
    actions.SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS,
    function* (action) {
      const { parameters, onSuccess } = action;
      try {
        const res = yield call(
          [axios, 'get'],
          `${SUBSCRIPTION_API_URL}/configuration/renewalNotification?${parameters.toString()}`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({ type: actions.SEARCH_SUBSCRIPTION_RENEWAL_NOTIFICATION_CONFIGURATIONS_ENDED });
      }
    },
  );
}

function* updateSubscriptionRenewalConfiguration() {
  yield takeEvery(actions.UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SUBSCRIPTION_API_URL}/configuration/renewal`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_SUBSCRIPTION_RENEWAL_CONFIGURATION_ENDED });
    }
  });
}

function* getSubscriptionProgramContractOrderRefundAmountInfo() {
  yield takeEvery(
    actions.GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO,
    function* (action) {
      const { id, onSuccess } = action;
      try {
        const res = yield call(
          [axios, 'get'],
          `${SUBSCRIPTION_PROGRAM_ORDER_API_URL}/${id}/getRefundAmountInfo`,
        );
        if (isFunction(onSuccess)) {
          yield call(onSuccess, res.data);
        }
      } catch (err) {
        yield handleError(err);
      } finally {
        yield put({
          type: actions.GET_SUBSCRIPTION_PROGRAM_CONTRACT_ORDER_REFUND_AMOUNT_INFO_ENDED,
        });
      }
    },
  );
}

function* createCreditBySubscriptionProgramOrder() {
  yield takeEvery(actions.CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${SUBSCRIPTION_PROGRAM_ORDER_API_URL}/issueCredit`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_CREDIT_BY_SUBSCRIPTION_PROGRAM_ORDER_ENDED });
    }
  });
}

function* searchProgramPrivilegeTickets() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/programPrivilegeTicket?${parameters}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_ACTIVITIES_END });
    }
  });
}

function* findProgramPrivilegeTicket() {
  yield takeEvery(actions.FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/programPrivilegeTicket/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SUBSCRIPTION_PROGRAM_PRIVILEGE_TICKET_END });
    }
  });
}

function* searchProgramMemberPrivilege() {
  yield takeEvery(actions.SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/memberPrivilege?${parameters}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END });
    }
  });
}

function* findProgramMemberPrivilege() {
  yield takeEvery(actions.FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${SUBSCRIPTION_API_URL}/programContract/memberPrivilege/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_SUBSCRIPTION_PROGRAM_MEMBER_PRIVILEGE_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchSubscriptionActivities),
    fork(findSubscriptionActivity),
    fork(createSubscriptionActivity),
    fork(updateSubscriptionActivity),
    fork(deleteSubscriptionActivities),
    fork(searchSubscriptionPrograms),
    fork(findSubscriptionProgram),
    fork(createSubscriptionProgram),
    fork(updateSubscriptionProgram),
    fork(deleteSubscriptionPrograms),
    fork(getSubscriptionReceiptConfiguration),
    fork(updateSubscriptionReceiptConfiguration),
    fork(getSubscriptionHandlingFeeConfiguration),
    fork(updateSubscriptionHandlingFeeConfiguration),
    fork(getSubscriptionRenewalConfiguration),
    fork(searchSubscriptionRenewalNotificationConfigurations),
    fork(updateSubscriptionRenewalConfiguration),
    fork(searchSubscriptionProgramContracts),
    fork(searchSubscriptionProgramContractOrders),
    fork(searchMemberPrivilegeUsageTransactionRecords),
    fork(subscriptionProgramOrderRefund),
    fork(subscriptionProgramOrderRefundByManually),
    fork(getSubscriptionProgramContractOrderRefundAmountInfo),
    fork(createCreditBySubscriptionProgramOrder),
    fork(searchProgramPrivilegeTickets),
    fork(findProgramPrivilegeTicket),
    fork(searchProgramMemberPrivilege),
    fork(findProgramMemberPrivilege),
  ]);
}
